export default __webpack_public_path__ + "static/toolkit-a668a7b05ec865bfaed33662283e5e0f.png";